import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';

// bootstrap the application / store
applicationBootstrap().then(() => {
  roller();
});
